// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   SKELETON SCREEN LOADERS — Shimmer Animation System
   ═══════════════════════════════════════════════════════════════ */

/* ── Shimmer Keyframes ─────────────────────────────────────── */
@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* ── Base Bone ─────────────────────────────────────────────── */
.skeleton-bone {
  background: linear-gradient(
    90deg,
    hsl(var(--muted)) 25%,
    hsl(var(--muted-foreground) / 0.08) 37%,
    hsl(var(--muted)) 63%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s ease-in-out infinite;
  border-radius: calc(var(--radius) - 2px);
  will-change: background-position;
  transform: translateZ(0); /* Force GPU layer */
}

/* ── Shape Variants ────────────────────────────────────────── */
.skeleton-circle {
  border-radius: 9999px;
}

.skeleton-rounded-lg {
  border-radius: var(--radius);
}

.skeleton-rounded-xl {
  border-radius: calc(var(--radius) + 4px);
}

.skeleton-rounded-2xl {
  border-radius: calc(var(--radius) + 8px);
}

.skeleton-rounded-3xl {
  border-radius: calc(var(--radius) + 12px);
}

.skeleton-rounded-full {
  border-radius: 9999px;
}

/* ── Stagger Animation Delays ──────────────────────────────── */
.skeleton-stagger-1 { animation-delay: 0ms; }
.skeleton-stagger-2 { animation-delay: 75ms; }
.skeleton-stagger-3 { animation-delay: 150ms; }
.skeleton-stagger-4 { animation-delay: 225ms; }
.skeleton-stagger-5 { animation-delay: 300ms; }
.skeleton-stagger-6 { animation-delay: 375ms; }
.skeleton-stagger-7 { animation-delay: 450ms; }
.skeleton-stagger-8 { animation-delay: 525ms; }
.skeleton-stagger-9 { animation-delay: 600ms; }
.skeleton-stagger-10 { animation-delay: 675ms; }

/* ── Page Skeleton Container ───────────────────────────────── */
.skeleton-page {
  min-height: 100vh;
  padding: 1rem;
}

@media (min-width: 768px) {
  .skeleton-page {
    padding: 2rem;
  }
}

/* ── Skeleton Card (Product) ───────────────────────────────── */
.skeleton-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: hidden;
}

.skeleton-card-thumbnail {
  width: 100%;
  aspect-ratio: 3 / 4;
}

.skeleton-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.25rem 0;
}

.skeleton-card-title {
  height: 0.875rem;
  width: 72%;
}

.skeleton-card-subtitle {
  height: 0.75rem;
  width: 48%;
}

.skeleton-card-price {
  height: 0.875rem;
  width: 28%;
  margin-top: 0.125rem;
}

/* ── Skeleton List Item (Historique) ────────────────────────── */
.skeleton-list-item {
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: var(--radius);
  background: hsl(var(--card));
  border: 1px solid hsl(var(--border));
}

@media (min-width: 768px) {
  .skeleton-list-item {
    gap: 1rem;
    padding: 1rem;
  }
}

.skeleton-list-thumb {
  width: 5rem;
  height: 5rem;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .skeleton-list-thumb {
    width: 6rem;
    height: 6rem;
  }
}

.skeleton-list-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.375rem;
  min-width: 0;
}

.skeleton-list-title {
  height: 0.875rem;
  width: 60%;
}

.skeleton-list-brand {
  height: 0.625rem;
  width: 35%;
}

.skeleton-list-badge {
  height: 1.5rem;
  width: 4.5rem;
}

.skeleton-list-date {
  height: 0.625rem;
  width: 8rem;
}

/* ── Skeleton Profile Header ───────────────────────────────── */
.skeleton-profile-banner {
  height: 12rem;
  width: 100%;
}

.skeleton-profile-avatar {
  width: 8rem;
  height: 8rem;
  margin-top: -4rem;
  border: 4px solid hsl(var(--background));
}

.skeleton-profile-name {
  height: 1.75rem;
  width: 10rem;
}

.skeleton-profile-email {
  height: 1rem;
  width: 14rem;
}

/* ── Skeleton Search Bar ───────────────────────────────────── */
.skeleton-searchbar {
  height: 2.5rem;
  width: 100%;
  max-width: 28rem;
}

@media (min-width: 768px) {
  .skeleton-searchbar {
    height: 3rem;
    max-width: 42rem;
  }
}

.skeleton-filter-btn {
  height: 2.5rem;
  width: 5.5rem;
}

@media (min-width: 768px) {
  .skeleton-filter-btn {
    height: 3rem;
  }
}

/* ── Skeleton Header Text ──────────────────────────────────── */
.skeleton-header-title {
  height: 1.875rem;
  width: 10rem;
}

.skeleton-header-subtitle {
  height: 0.875rem;
  width: 8rem;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/ui/skeleton.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE,iEAAiE;AACjE;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,iEAAiE;AACjE;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;EACrD,wCAAwC;EACxC,gCAAgC;EAChC,wBAAwB,EAAE,oBAAoB;AAChD;;AAEA,iEAAiE;AACjE;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE,sBAAsB,oBAAoB,EAAE;AAC5C,sBAAsB,qBAAqB,EAAE;AAC7C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,sBAAsB,EAAE;AAC9C,uBAAuB,sBAAsB,EAAE;;AAE/C,iEAAiE;AACjE;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   SKELETON SCREEN LOADERS — Shimmer Animation System\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Shimmer Keyframes ─────────────────────────────────────── */\n@keyframes skeleton-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* ── Base Bone ─────────────────────────────────────────────── */\n.skeleton-bone {\n  background: linear-gradient(\n    90deg,\n    hsl(var(--muted)) 25%,\n    hsl(var(--muted-foreground) / 0.08) 37%,\n    hsl(var(--muted)) 63%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 1.5s ease-in-out infinite;\n  border-radius: calc(var(--radius) - 2px);\n  will-change: background-position;\n  transform: translateZ(0); /* Force GPU layer */\n}\n\n/* ── Shape Variants ────────────────────────────────────────── */\n.skeleton-circle {\n  border-radius: 9999px;\n}\n\n.skeleton-rounded-lg {\n  border-radius: var(--radius);\n}\n\n.skeleton-rounded-xl {\n  border-radius: calc(var(--radius) + 4px);\n}\n\n.skeleton-rounded-2xl {\n  border-radius: calc(var(--radius) + 8px);\n}\n\n.skeleton-rounded-3xl {\n  border-radius: calc(var(--radius) + 12px);\n}\n\n.skeleton-rounded-full {\n  border-radius: 9999px;\n}\n\n/* ── Stagger Animation Delays ──────────────────────────────── */\n.skeleton-stagger-1 { animation-delay: 0ms; }\n.skeleton-stagger-2 { animation-delay: 75ms; }\n.skeleton-stagger-3 { animation-delay: 150ms; }\n.skeleton-stagger-4 { animation-delay: 225ms; }\n.skeleton-stagger-5 { animation-delay: 300ms; }\n.skeleton-stagger-6 { animation-delay: 375ms; }\n.skeleton-stagger-7 { animation-delay: 450ms; }\n.skeleton-stagger-8 { animation-delay: 525ms; }\n.skeleton-stagger-9 { animation-delay: 600ms; }\n.skeleton-stagger-10 { animation-delay: 675ms; }\n\n/* ── Page Skeleton Container ───────────────────────────────── */\n.skeleton-page {\n  min-height: 100vh;\n  padding: 1rem;\n}\n\n@media (min-width: 768px) {\n  .skeleton-page {\n    padding: 2rem;\n  }\n}\n\n/* ── Skeleton Card (Product) ───────────────────────────────── */\n.skeleton-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow: hidden;\n}\n\n.skeleton-card-thumbnail {\n  width: 100%;\n  aspect-ratio: 3 / 4;\n}\n\n.skeleton-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  padding: 0.25rem 0;\n}\n\n.skeleton-card-title {\n  height: 0.875rem;\n  width: 72%;\n}\n\n.skeleton-card-subtitle {\n  height: 0.75rem;\n  width: 48%;\n}\n\n.skeleton-card-price {\n  height: 0.875rem;\n  width: 28%;\n  margin-top: 0.125rem;\n}\n\n/* ── Skeleton List Item (Historique) ────────────────────────── */\n.skeleton-list-item {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border-radius: var(--radius);\n  background: hsl(var(--card));\n  border: 1px solid hsl(var(--border));\n}\n\n@media (min-width: 768px) {\n  .skeleton-list-item {\n    gap: 1rem;\n    padding: 1rem;\n  }\n}\n\n.skeleton-list-thumb {\n  width: 5rem;\n  height: 5rem;\n  flex-shrink: 0;\n}\n\n@media (min-width: 768px) {\n  .skeleton-list-thumb {\n    width: 6rem;\n    height: 6rem;\n  }\n}\n\n.skeleton-list-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0.375rem;\n  min-width: 0;\n}\n\n.skeleton-list-title {\n  height: 0.875rem;\n  width: 60%;\n}\n\n.skeleton-list-brand {\n  height: 0.625rem;\n  width: 35%;\n}\n\n.skeleton-list-badge {\n  height: 1.5rem;\n  width: 4.5rem;\n}\n\n.skeleton-list-date {\n  height: 0.625rem;\n  width: 8rem;\n}\n\n/* ── Skeleton Profile Header ───────────────────────────────── */\n.skeleton-profile-banner {\n  height: 12rem;\n  width: 100%;\n}\n\n.skeleton-profile-avatar {\n  width: 8rem;\n  height: 8rem;\n  margin-top: -4rem;\n  border: 4px solid hsl(var(--background));\n}\n\n.skeleton-profile-name {\n  height: 1.75rem;\n  width: 10rem;\n}\n\n.skeleton-profile-email {\n  height: 1rem;\n  width: 14rem;\n}\n\n/* ── Skeleton Search Bar ───────────────────────────────────── */\n.skeleton-searchbar {\n  height: 2.5rem;\n  width: 100%;\n  max-width: 28rem;\n}\n\n@media (min-width: 768px) {\n  .skeleton-searchbar {\n    height: 3rem;\n    max-width: 42rem;\n  }\n}\n\n.skeleton-filter-btn {\n  height: 2.5rem;\n  width: 5.5rem;\n}\n\n@media (min-width: 768px) {\n  .skeleton-filter-btn {\n    height: 3rem;\n  }\n}\n\n/* ── Skeleton Header Text ──────────────────────────────────── */\n.skeleton-header-title {\n  height: 1.875rem;\n  width: 10rem;\n}\n\n.skeleton-header-subtitle {\n  height: 0.875rem;\n  width: 8rem;\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
